/**
 * The language a person's words are in, by the script they are written in. Used only when the ears did not name one
 * (the live transcription model reports no language). Hebrew letters, Arabic letters or Latin letters, by the majority
 * of WORDS; a capitalised Latin word inside a Hebrew or Arabic sentence is a name and counts for nothing, and a Hebrew
 * or Arabic word inside an English sentence is one word among many, so neither flips the sentence.
 * Returns 'he' | 'ar' | 'en', or null when there are no letters (the caller keeps the language it already has).
 */
const HEBREW = /[֐-׿]/;
const ARABIC = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/;
const LATIN = /[A-Za-zÀ-ɏ]/;

export function languageOf(text) {
  const words = String(text ?? '').split(/[^\p{L}\p{M}'’]+/u).filter(Boolean);
  let he = 0; let ar = 0; let en = 0; let nameLike = 0;
  for (const w of words) {
    if (HEBREW.test(w)) he += 1;
    else if (ARABIC.test(w)) ar += 1;
    else if (LATIN.test(w)) { en += 1; if (/^[A-Z]/.test(w)) nameLike += 1; }
  }
  if (he + ar + en === 0) return null;
  // Capitalised Latin words in a sentence that has Hebrew or Arabic words are names (Daniel, Sabai Sabai).
  const effectiveEn = he + ar > 0 ? en - nameLike : en;
  if (he === 0 && ar === 0) return 'en';
  const best = Math.max(he, ar);
  // Ties go to the non-Latin script: the person is speaking Hebrew or Arabic around a Latin word.
  return effectiveEn > best ? 'en' : he >= ar ? 'he' : 'ar';
}
